/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="login.model.ts" />
/// <reference path="../base/base.service.ts" />

module Eseebase {
    export class UserService {
        private user: UserModel;
        private currentUser: UserModel;
        constructor(private $http: ng.IHttpService, private baseService: BaseService, private $q: ng.IQService, private cookiesService: CookiesService) { }

        public authenticate(login: LoginModel) {
            return this.baseService.postAsForm('token', { username: login.email, password: login.password, grant_type: 'password', client_id: 'ngAuthApp', remember_me: login.rememberMe });
        }

        public refreshAccessToken(refreshToken: string) {
            return this.baseService.postAsForm('token', { refresh_token: refreshToken, grant_type: 'refresh_token', client_id: 'ngAuthApp' });
        }

        public logout(refreshToken: string | null) {
            return this.baseService.post('user/logout', { refreshToken: refreshToken, clientId: 'ngAuthApp', logoutType: 'ThisSessionOnly' });
        }

        public changePassword(userId: string, currentPassword: string, newPassword: string) {
            return this.baseService.postAsForm('user/changePassword', { userId: userId, currentPassword: currentPassword, newPassword: newPassword });
        }

        public updateUser(user: UserModel) {
            if (user != null && this.user != null && user.email == this.user.email) {
                this.user = user;
            }
        }

        public getUserById(id:string) {
            return this.baseService.get('user/get?id=' + id).then(j => { return j.data });
        }

        public validateToken(token: string) {
            return this.baseService.get('user/isvalid?token=' + token).then(j => { return j.data });
        }

        public resetPassword(token: string, password: string) {
            return this.baseService.post('user/resetpassword?token=' + token + '&password=' + password, {}).then(j => { return j.data });
        }

        public getUser(force?: boolean): ng.IPromise<UserModel> {
            var deferred = this.$q.defer();
            var vm = this;
            if (this.user == null || force) {
                this.baseService.get('user/get').then((data) => {
                    vm.user = <UserModel>data.data;
                    deferred.resolve(vm.user);
                },
                (reason) => {
                    deferred.reject(reason);
                });
            }
            else
            {
                deferred.resolve(this.user);
            }
            return <ng.IPromise<UserModel>>deferred.promise;
        }

        public getUsers() {
            var deferred = this.$q.defer();
            this.baseService.get('user/list').then((data) => {
                deferred.resolve(data.data);
            },
            (reason) => {
                deferred.reject(reason);
            });
            return deferred.promise;
        }

        public sendPassword(email: string) {
            return this.baseService.post('user/' + email + '/sendpassword', null);
        }

        public getRoles() {
            var deferred = this.$q.defer();
            this.baseService.get('user/roles').then((data) => {
                if (data != null && data.data != null) {
                    deferred.resolve(data.data);
                }
                else {
                    deferred.reject(401);
                }
            },
            (reason) => {
                deferred.reject(reason);
            });

            return deferred.promise;
        }

        public saveAccessToken(login: LoginModel, store: boolean)
        {
            this.baseService.saveAccessToken(login.accessToken);
            this.baseService.saveRefreshToken(login.refreshToken, store);
        }

        public removeAccessToken() {
            var refreshToken = this.cookiesService.readCookie('refreshToken');
            this.logout(refreshToken).then(d => {
                this.user = null;
                this.cookiesService.deleteCookie("modelFilter");
                return this.baseService.removeAccessToken();
            });
        }

        public createOrUpdate(user: UserModel) {
            var deferred = this.$q.defer();
            var vm = this;
            this.baseService.put('user', user).then((data) => {
                // warning: the data object sits on data.config.data, not data.data 
                if (data != null && data.data != null) {
                    deferred.resolve(data.data);
                }
                else {
                    deferred.reject(401);
                }
            },
            (reason) => {
                deferred.reject(reason);
            });
            return deferred.promise;
        }
    }

    UserService.$inject = ['$http', 'BaseService', '$q', 'CookiesService'];
    angular
        .module('eseebase')
        .service('UserService', UserService);
}